import LandPlotWebSvg from '@assets/images/svg/land-plot-web.svg';
import React from 'react';
import { View } from 'react-native';

export interface LandPlotWebIconProps {
    size?: number;
    color?: string;
}

/**
 * Web-safe variant of LandPlotIcon (no clipPath wrapper in the SVG).
 * See DumbbellWebIcon for details on the web clipPath id collision.
 */
export function LandPlotWebIcon({ size = 19, color = '#1A1A1A' }: Readonly<LandPlotWebIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <LandPlotWebSvg width={size} height={size} color={color} />
        </View>
    );
}

export default LandPlotWebIcon;
